<script setup>
// import gb from "@/components/bg.vue";
import axios from "axios";
import Swal from "sweetalert2";
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

const store = useStore();
const router = useRouter();

const forgot_pw_win = ref(false);

const pw_type = ref("password");

/*------▼人物動畫▼------*/
const venus = ref(null);
const earth = ref(null);

function animateFog(element, speedX, speedY) {
  let posX = 0;
  let posY = 0;

  // 獲取當前的縮放比例
  const currentZoom = window.devicePixelRatio || 1;

  // 反向縮放，使之看起來像 100%
  const inverseZoom = 1 / currentZoom;

  // transform:translate(${Math.sin(posX) * 5}px, ${Math.sin(posY) * 20}px); transform-origin:50% 50%;

  function animate() {
    posX += speedX;
    posY += speedY;

    element.style.cssText = `zoom:${inverseZoom}`;

    // requestAnimationFrame(animate);
  }

  animate();
}
/*------▲人物動畫▲------*/

/*------▼視窗縮放▼------*/

const login_win = ref(null);
const logo = ref(null);

function adjustScale(element) {
  // 獲取當前的縮放比例
  const currentZoom = window.devicePixelRatio || 1;

  // 反向縮放，使之看起來像 100%
  const inverseZoom = 1 / currentZoom;

  // 使用 CSS transform 來反向縮放
  if (element !== logo.value) {
    element.style.transform = `translate(-50%, -50%) scale(${inverseZoom})`;
  } else {
    let yx = `-${100 - (inverseZoom * 100 - inverseZoom)}%`;
    element.style.transform = `scale(${inverseZoom}) translate(${yx}, ${yx})`;
  }
}

/*------▲視窗縮放▲------*/

/*------▼帳號登入▼------*/
const ac = ref(null);
const pw = ref(null);

const remember = ref(false);

function login() {
  // 如果沒有找到符合的帳號，則給回饋
  if (!ac.value) {
    Swal.fire({
      title: "Error",
      text: "Please check your account.",
      icon: "error",
      confirmButtonText: "Close",
    });
    return;
  }

  if (!pw.value) {
    Swal.fire({
      title: "Error",
      text: "Please check your password.",
      icon: "error",
      confirmButtonText: "Close",
    });
    return;
  }

  // Show loading screen
  Swal.fire({
    title: "Logging in...",
    text: "Please wait while we process your login.",
    allowOutsideClick: false, // Disable background click to close
    allowEscapeKey: false, // Disable Esc to close
    showCloseButton: false, // No close button
    didOpen: () => {
      Swal.showLoading(); // Show loading animation
    },
  });

  const FormData = require("form-data");
  let data = new FormData();
  data.append("tch_account", ac.value);
  data.append("tch_password", pw.value);
  data.append("jwt_aud", "web");

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${store.state.path}api/db/teacher-login/get`,
    data: data,
  };

  axios
    .request(config)
    .then((response) => {
      Swal.close(); // Close the loading screen when response is received

      if (response.status !== 200) {
        Swal.fire({
          title: "Error",
          text: "Please check your account and password.",
          icon: "error",
          confirmButtonText: "Close",
        });
        return;
      }

      // if (remember) {
      //   localStorage.setItem("remember", true);
      // } else {
      //   localStorage.removeItem("remember");
      // }

      if (response.data.code == -2) {
        // 帳號沒有權限
        Swal.fire({
          title: "Error",
          text: "This account is not enabled.",
          icon: "error",
          confirmButtonText: "Close",
        });
        return;
      }

      if (response.data.code == -3) {
        // 帳號到期
        Swal.fire({
          title: "Error",
          text: "This account has expired.",
          icon: "error",
          confirmButtonText: "Close",
        });
        return;
      }

      if (response.data.msg !== "login success") {
        let _day_ = response.data.data.days_left;

        if (_day_ <= 30) {
          Swal.fire({
            text: `Login successfully. Your account has ${_day_} day(s) left to expire.`,
            icon: "warning",
            confirmButtonText: "OK",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCloseButton: false,
          }).then((result) => {
            if (result.isConfirmed) {
              Swal.fire({
                title: "Information",
                text: "Login successfully.",
                icon: "success",
                confirmButtonText: "OK",
                allowOutsideClick: false,
                allowEscapeKey: false,
                showCloseButton: false,
              }).then((result) => {
                if (result.isConfirmed) {
                  localStorage.setItem("school_guid", response.data.tch_guid);
                  localStorage.setItem("ac", ac.value);
                  // localStorage.setItem("pw", pw.value);
                  localStorage.setItem("token", response.data.token);
                  router.push("/choose");
                }
              });
            }
          });
        } else {
          localStorage.setItem("school_guid", response.data.tch_guid);
          localStorage.setItem("ac", ac.value);
          // localStorage.setItem("pw", pw.value);
          localStorage.setItem("token", response.data.token);
          router.push("/choose");
        }
      } else {
        Swal.fire({
          title: "Information",
          text: "Login successfully.",
          icon: "success",
          confirmButtonText: "OK",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCloseButton: false,
        }).then((result) => {
          if (result.isConfirmed) {
            localStorage.setItem("school_guid", response.data.tch_guid);
            localStorage.setItem("ac", ac.value);
            localStorage.setItem("pw", pw.value);
            localStorage.setItem("token", response.data.token);
            router.push("/choose");
          }
        });
      }
    })
    .catch((err) => {
      Swal.close(); // Close the loading screen in case of error

      if (err.response && err.response.data.code == -2) {
        // 帳號沒有權限
        Swal.fire({
          title: "Error",
          text: "This account is not enabled.",
          icon: "error",
          confirmButtonText: "Close",
        });
        return;
      }

      if (err.response && err.response.data.code == -3) {
        // 帳號到期
        Swal.fire({
          title: "Error",
          text: "This account has expired.",
          icon: "error",
          confirmButtonText: "Close",
        });
        return;
      }

      Swal.fire({
        title: "Error",
        text: "Please check your account and password.",
        icon: "error",
        confirmButtonText: "Close",
      });
    });
}

const change_ac = ref(null);
const email = ref(null);

function change_pw() {
  if (!change_ac.value) {
    Swal.fire({
      title: "Error",
      text: "Please check your account.",
      icon: "error",
      confirmButtonText: "關閉",
    });
    return;
  }

  if (!email.value) {
    Swal.fire({
      title: "Error",
      text: "Please input your e-mail address.",
      icon: "error",
      confirmButtonText: "Close",
    });
    return;
  }

  // 正則表達式檢查信箱格式
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!emailPattern.test(email.value)) {
    Swal.fire({
      title: "Error",
      text: "Please check your e-mail address.",
      icon: "error",
      confirmButtonText: "Close",
    });
    return;
  }

  // 送出成功
  Swal.fire({
    title: "Information",
    text: "Please check the letter by e-mail.",
    icon: "success",
    confirmButtonText: "OK",
    allowOutsideClick: false, // 禁止點擊背景關閉
    allowEscapeKey: false, // 禁止按Esc鍵關閉
    showCloseButton: false, // 不顯示右上角的關閉按鈕
  }).then((result) => {
    if (result.isConfirmed) {
      forgot_pw_win.value = false;
    }
  });
}
/*------▲帳號登入▲------*/

const adjustZoom = (view) => {
  const baseWidth = 1920;
  const baseHeight = 1080;

  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;

  const scaleWidth = windowWidth / baseWidth;
  const scaleHeight = windowHeight / baseHeight;

  const scale = Math.min(scaleWidth, scaleHeight);

  if (view) {
    if(view.id=='logo'){
      view.style.transform = `scale(${scale})`;
    }else{
      view.style.transform = `scale(${scale}) translate(-50%, -50%)`;
    }
  }
};

onMounted(() => {
  // get_info();

  /*------▼人物動畫 觸發▼------*/
  animateFog(venus.value, 0.02, 0.03);
  animateFog(earth.value, 0.01, 0.04);
  /*------▲人物動畫 觸發▲------*/

  /*------▼視窗縮放 觸發▼------*/
  adjustZoom(login_win.value);
  adjustZoom(logo.value);
  /*------▲視窗縮放 觸發▲------*/

  /*------▼如果有記住密碼 觸發▼------*/
  /*
  if (localStorage.getItem("remember") == "true") {
    console.log("有記住密碼");
    remember.value = true;
    ac.value = localStorage.getItem("ac");
    pw.value = localStorage.getItem("pw");
  }
  */
  /*------▲如果有記住密碼 觸發▲------*/
});
</script>

<template>
  <div id="login" class="wrapper">
    <!-- <gb /> -->

    <div id="logo" ref="logo">
      <img class="pci_logo" src="@/assets/images/new-logo.png" alt="star" />
    </div>

    <div id="login_win" ref="login_win" v-if="!forgot_pw_win">
      <form @submit.prevent="login">
        <div class="login_logo">
          <img src="@/assets/images/text_logo.svg" alt="login_logo" />
        </div>
        <div class="input">
          <span class="icon">
            <img src="@/assets/images/icon/user.svg" alt="icon" />
          </span>
          <input type="text" v-model="ac" placeholder="Account" />
        </div>
        <div class="input" style="position: relative;">
          <span class="icon">
            <img src="@/assets/images/icon/lock.svg" alt="icon" />
          </span>
          <input :type="pw_type" v-model="pw" placeholder="Password" />
          <div
            v-if="pw_type=='password'"
            @click="pw_type = 'text'"
            style="width: 45px;text-align: center;height: 45px; cursor: pointer;position: absolute;right: 30px;top: 50%;transform: translateY(-50%); display: flex; align-items: center; justify-content: center;"
          >
            <img src="@/assets/images/login/visibility_off.svg" alt="icon" />
          </div>
          <div
            v-else
            @click="pw_type = 'password'"
            style="width: 45px;text-align: center;height: 45px; cursor: pointer;position: absolute;right: 30px;top: 50%;transform: translateY(-50%); display: flex; align-items: center; justify-content: center;"
          >
            <img src="@/assets/images/login/visibility.svg" alt="icon" />
          </div>
        </div>

        <!-- <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <label class="checkbox">
            <input type="checkbox" v-model="remember" />
            <span class="checkbox_style">
              <img src="@/assets/images/icon/tick.svg" alt="tick" />
            </span>
            <span class="text" style="font-size: 18px">Remember me</span>
          </label>

          <div>
            <p>
              <a
                @click="forgot_pw_win = true"
                href="javascript:void(0)"
                style="
                  cursor: pointer;
                  color: #fff;
                  font-size: 18px;
                  font-weight: 500;
                  padding: 5px 10px;
                  border-radius: 25px;
                  text-decoration: underline;
                "
              >
                Forgot Password?
              </a>
            </p>
          </div>
        </div> -->

        <div class="btn">
          <button type="submit">LOG IN</button>
        </div>
      </form>
    </div>

    <div id="forgot_pw_win" v-else>
      <h3>Forgot Password</h3>
      <form @submit.prevent="change_pw">
        <div class="input">
          <span class="icon">
            <img src="@/assets/images/icon/user.svg" alt="icon" />
          </span>
          <input type="text" v-model="change_ac" placeholder="Account" />
        </div>
        <div class="input">
          <span class="icon">
            <img src="@/assets/images/icon/lock.svg" alt="icon" />
          </span>
          <input type="email" v-model="email" placeholder="E-Meil" />
        </div>

        <div class="btn">
          <button type="submit">Send</button>
        </div>
      </form>

      <!-- 關閉 -->
      <button
        @click="forgot_pw_win = false"
        style="
          width: 35px;
          height: 35px;
          box-sizing: border-box;
          padding: 0;
          border: none;
          position: absolute;
          right: 15px;
          top: 15px;
          background-color: transparent;
          color: #fff;
          font-size: 22px;
          font-weight: 900;
        "
      >
        ×
      </button>
    </div>

    <div ref="venus" id="venus">
      <img src="@/assets/images/login/venus.svg" alt="venus" />
      <img class="figure" src="@/assets/images/login/Pat.png" alt="figure" />
    </div>

    <div ref="earth" id="earth">
      <img src="@/assets/images/login/earth.svg" alt="venus" />
      <img class="figure" src="@/assets/images/login/Milly.png" alt="figure" />
    </div>
  </div>
</template>
